<template>
  <div class="searchBox-container">
   
    <el-input v-model="input" placeholder="请输入内容" clearable @clear="clearInput"></el-input>
    <el-button type="primary" @click="sendKeyword">
      <i class="el-icon-search"></i>
      查询
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  data() {
    return {
      input: ''
    }
  },
  methods: {
    sendKeyword() {
      if (this.input.trim() !== '') {
        this.$emit('getKeyword', this.input)
      } else {
        this.$message({
          type: 'warning',
          message: '输入框不能为空！'
        })
      }
    },
    clearInput() {
      this.$emit('clearInput')
    }
  }
}
</script>

<style lang="scss" scoped>
.searchBox-container {
  display: flex;
  font-size: 14px;
  margin: 10px;

  p {
    margin: 10px;
    font-weight: 500px;
  }
  i {
    margin-right: 5px;
  }
  .el-input {
    width: 240px;
  }
  .el-button--primary {
    margin-left: 20px;
  }
}
</style>
